export default "__VITE_ASSET__opAMvShA__"